module.exports = __webpack_public_path__ + "images/faces-back-to-pattern.svg";